import { en } from '../i18n/en';

/** Extra words a player might type for a game: other names, short forms, the rules it is known by. */
export const GAME_ALIASES: Record<string, string[]> = {
  CALL_BREAK: ['callbreak', 'lakdi', 'tash'],
  SPADES: ['spade'],
  TARNEEB: ['tarneb', 'trix'],
  HEARTS: ['heart', 'queen of spades'],
  FIVE_HUNDRED: ['500', '5 hundred'],
  JUDGEMENT: ['judgment', 'oh hell', 'kachuful', 'bidding'],
  RUMMY: ['rummi', 'indian rummy', '13 cards', 'sequence'],
  EUCHRE: ['euker', 'bower'],
  GIN_RUMMY: ['gin', 'knock'],
  TWENTY_NINE: ['29', 'twenty nine', 'rang'],
  CRAZY_EIGHTS: ['8s', 'eights', 'crazy 8'],
  CRIBBAGE: ['crib', 'pegging'],
  BLACKJACK: ['21', 'twenty one', 'black jack', 'casino'],
  BHABHI: ['thulla', 'thulle', 'old maid'],
  PINOCHLE: ['pinocle', 'meld'],
  ANDAR_BAHAR: ['andar', 'bahar', 'inside outside', 'casino'],
  BRIDGE: ['contract bridge', 'dummy'],
  SEVENS: ['satte pe satta', 'satta', 'fan tan', 'sevens'],
  SCOPA: ['sweep', 'seep', 'capture', 'italian'],
  BACCARAT: ['punto banco', 'casino'],
  BLUFF: ['cheat', 'bs', 'i doubt it', 'liar'],
  DRAGON_TIGER: ['dragon', 'tiger', 'dt', 'casino', 'high card'],
  FLUSH: ['flash', 'colour', 'color', '3 card', 'three card'],
  COURT_PIECE: ['rang', 'rung', 'court', 'coat piece', 'trump'],
  DEHLA_PAKAD: ['dehla', 'dahla', 'pakad', 'mendicot', 'mindi', 'tens', 'dahala'],
  WHIST: ['wist', 'classic', 'trump', 'tricks'],
  SEEP: ['sip', 'house', 'houses', 'floor'],
  BELOTE: ['belote', 'french', 'rebelote', 'coinche', 'trump'],
  DURAK: ['fool', 'russian', 'podkidnoy'],
  PRESIDENT: ['asshole', 'scum', 'daifugo', 'bum', 'shedding'],
  BRISCOLA: ['briscola', 'italian', 'brisca'],
  CASINO_WAR: ['war', 'casino', 'high card'],
  THREE_CARD_POKER: ['3 card poker', 'tcp', 'ante play', 'poker', 'casino', 'pair plus'],
  GO_FISH: ['fish', 'ask', 'books', 'kids', 'family'],
  TRESSETTE: ['tressette', 'italian', 'three seven', 'tre sette'],
  RED_DOG: ['red dog', 'acey deucey', 'in between', 'casino', 'spread'],
  CANASTA: ['canasta', 'melds', 'wild', 'sevens'],
  SKAT: ['skat', 'german', 'jack', 'grand', 'null'],
  PAI_GOW: ['pai gow', 'paigow', 'two hands', 'casino', 'poker', 'chinese'],
  BIG_TWO: ['big 2', 'deuces', 'pusoy', 'pusoy dos', 'tien len', 'chinese poker'],
  WAR: ['card war', 'battle', 'kids', 'flip'],
  RUMMY_500: ['500 rum', 'rum 500', 'pinochle rummy'],
  BRAG: ['brag', 'three card brag', '3 card brag', 'prial', 'british'],
  PITCH: ['setback', 'pitch', 'high low jack', 'smear'],
  HAZARI: ['hazari', 'hazar', '1000', 'thousand', 'tin hazari'],
  TEEN_PATTI: ['3 patti', 'teen patti', 'three card', 'flush', 'casino'],
  POKER: ['texas', 'holdem', "hold'em", 'omaha', 'plo', 'casino'],
  MARRIAGE: ['shaadi', 'mariage', 'tunnela'],
};

const fold = (s: string): string => s.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '');

/** Does the game match the search words? Every word must appear in its names or aliases. */
export function gameMatches(type: string, localName: string, query: string): boolean {
  const words = fold(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const english = (en as Record<string, string>)[`game.${type}`] ?? '';
  const hay = fold([localName, english, type.replace(/_/g, ' '), ...(GAME_ALIASES[type] ?? [])].join(' '));
  return words.every((w) => hay.includes(w));
}

export function filterGames<T extends { type: string }>(games: readonly T[], query: string, localName: (type: string) => string): T[] {
  return games.filter((g) => gameMatches(g.type, localName(g.type), query));
}
